"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollCalendarButton = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const chevronLeftCircle_svg_1 = __importDefault(require("../../../../../assets/icons/chevronLeftCircle.svg"));
const chevronRightCircle_svg_1 = __importDefault(require("../../../../../assets/icons/chevronRightCircle.svg"));
const mobileChevronLeft_svg_1 = __importDefault(require("../../../../../assets/icons/mobileChevronLeft.svg"));
const mobileChevronRight_svg_1 = __importDefault(require("../../../../../assets/icons/mobileChevronRight.svg"));
const useScreenSizeDetection_1 = __importDefault(require("../../../../../utils/useScreenSizeDetection"));
const ScrollButton_1 = require("../../../../atoms/ScrollButton/ScrollButton");
const ScrollCalendarButton = ({ direction, handleClick, disabled = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const icon = isMobile
        ? direction === -1 /* MovesKeys.MOVE_BACKWARD */
            ? mobileChevronLeft_svg_1.default
            : mobileChevronRight_svg_1.default
        : direction === -1 /* MovesKeys.MOVE_BACKWARD */
            ? chevronLeftCircle_svg_1.default
            : chevronRightCircle_svg_1.default;
    const altText = direction === -1 /* MovesKeys.MOVE_BACKWARD */
        ? t("calendarPage.backScrollButton")
        : t("calendarPage.forwardScrollButton");
    return (react_1.default.createElement(ScrollButton_1.ScrollButton, { onClick: handleClick, disabled: disabled },
        react_1.default.createElement("img", { src: icon, alt: altText })));
};
exports.ScrollCalendarButton = ScrollCalendarButton;
